import * as React from 'react';

// Components
import { InputUsername } from '@shopee-user/input';

// Hooks
import { useTranslation } from '@shopee-user/platform';

// Types
import { InputProps } from '@shopee-user/input';

export const MAX_USERNAME_LENGTH = 41;

function LoginByPasswordInputAuthKey(props: InputProps) {
  const I18n = useTranslation();
  return (
    <InputUsername
      type="text"
      placeholder={I18n.t('label_auth_phone_number_or_username')}
      showError
      showErrorOutline
      autoFocus
      maxLength={MAX_USERNAME_LENGTH}
      {...props}
    />
  );
}

export default LoginByPasswordInputAuthKey;
